export var NumberReduction;
(function (NumberReduction) {
    NumberReduction["ANY"] = "any";
    NumberReduction["SUM"] = "sum";
    NumberReduction["MIN"] = "min";
    NumberReduction["MAX"] = "max";
})(NumberReduction || (NumberReduction = {}));
export function reduceNumberArray(data, reduction, initialValue) {
    // Preprocess and validate the numeric data
    const numericData = data.filter((value) => typeof value === 'number'); // help the linter
    if (numericData.length === 0)
        return initialValue;
    // Reduce to a single numeric value
    switch (reduction) {
        case NumberReduction.ANY:
            return numericData[0];
        case NumberReduction.SUM:
            return numericData.reduce((prevValue, curValue) => prevValue + curValue);
        case NumberReduction.MIN:
            return Math.min(...numericData);
        case NumberReduction.MAX:
            return Math.max(...numericData);
        default:
            return initialValue;
    }
}
